
const Spinner = props => {
    return (
        <div
            style={{
                width: 60,
                height: 60,
                border: `4px solid ${props.theme.Checo}`,
                borderTop: `4px solid ${props.theme.Magenta}`,
                borderRadius: 30,
                margin: 'auto',
                animation: 'spin 1s linear infinite'
            }}       
            className="spinner"
        />
    )
}

export default Spinner;